// Unpublished Work © 2024 Deere & Company.

import {action, observable} from 'mobx';

interface State {
    userToggles: string[];
    orgToggles: Record<string, string[] | undefined>;
}

export const togglesStore: State = observable({
    userToggles: [],
    orgToggles: {}
});

export const setUserFeatureToggles = action((userFeatureToggles: string[]): void => {
    togglesStore.userToggles = userFeatureToggles;
});

export const setOrgFeatureToggles = action((orgFeatureToggles: Record<string, string[] | undefined>): void => {
    togglesStore.orgToggles = orgFeatureToggles;
});
